import { useAllSearchParams, useRouter } from '@capsicum/common-web';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

export const useFocusBasketItemDigest = (
	focusedTeamId: null | string,
	teamId: string,
	refObject: React.RefObject<HTMLInputElement>
) => {
	const searchParams = useAllSearchParams();
	const router = useRouter();
	const pathname = usePathname();

	useEffect(() => {
		if (focusedTeamId === teamId && refObject.current) {
			setTimeout(() => {
				refObject.current?.focus();
			}, 0);

			const newParams = new URLSearchParams(searchParams);

			newParams.delete('focusedTeamId');

			const newUrl = newParams.toString() ? `${pathname}?${newParams.toString()}` : pathname;

			router.replace(newUrl);
		}
	}, [focusedTeamId, teamId]);

	return null;
};
